(function () {
    'use strict';

    angular.module('taillightUx').directive('tuxLoadingIndicator', [function () {
        return {
            restrict: 'E',
            bindToController: true,
            controller: function(){},
            controllerAs: 'loader',
            scope: {},
            template: [
                '<div class="tux-loading-indicator">',
                    '<div class="loader">',
                        '<div class="arc"></div>',
                    '</div>',
                '</div>'
            ].join('')
        };
    }]);
})();
